import { defineStore } from 'pinia';
import dynamicUiText from '@/helpers/dynamicUiText';
import { bumpTerminologyRevision } from '@/helpers/terminologyReactive';

/**
 * Reactive store for the active asset-type terminology context.
 * Global asset type comes from localStorage (set at login).
 * Record asset type is stored in dynamicUiText module context for detail views.
 */
export const useTerminologyStore = defineStore('terminology', {
    state: () => ({
        assetType: dynamicUiText.getStoredAssetType(),
        revision: 0
    }),
    getters: {
        activeAssetType() {
            return dynamicUiText.resolveActiveAssetType();
        },
        supportedAssetType() {
            return dynamicUiText.resolveSupportedAssetType(this.activeAssetType);
        },
        isCompaniesAndLlcs() {
            return this.supportedAssetType === dynamicUiText.COMPANIES_AND_LLCS_LABEL;
        },
        hasActiveTerminology() {
            return dynamicUiText.shouldApplyAssetTerminology(this.activeAssetType);
        },
        terminology(state) {
            void state.revision;
            return dynamicUiText.getTerminologyContextForAssetType(this.activeAssetType, true);
        }
    },
    actions: {
        syncFromStorage() {
            this.assetType = dynamicUiText.getStoredAssetType();
            dynamicUiText.clearTerminologyCache();
            this.revision += 1;
            bumpTerminologyRevision();
        },
        setRecordAssetType(assetType) {
            const normalized = assetType ? String(assetType).trim() : null;
            const current = dynamicUiText.getRecordAssetTypeContext();
            if (current === normalized) {
                return;
            }
            dynamicUiText.setRecordAssetTypeContext(normalized);
            this.revision += 1;
            bumpTerminologyRevision();
        },
        clearRecordAssetType() {
            if (!dynamicUiText.getRecordAssetTypeContext()) {
                return;
            }
            dynamicUiText.clearRecordAssetTypeContext();
            this.revision += 1;
            bumpTerminologyRevision();
        },
        /** Clears per-record terminology and forces UI recomputation on route navigation. */
        prepareForRouteNavigation() {
            dynamicUiText.clearRecordAssetTypeContext();
            dynamicUiText.clearTerminologyCache();
            this.revision += 1;
            bumpTerminologyRevision();
        }
    }
});

export default useTerminologyStore;
